import { render, staticRenderFns } from "./TableNavigation.vue?vue&type=template&id=f906fe42&"
import script from "./TableNavigation.vue?vue&type=script&lang=js&"
export * from "./TableNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TableNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports